import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import {BoundingBox} from '../../domain';
import L from "leaflet";

interface ExistingFeaturesButtonProps extends MapControlProps {
    toggleShowExistingFeatures: (bbox: BoundingBox) => void;
    shouldEnable: boolean;
}
class ExistingFeaturesButton extends MapControl<ExistingFeaturesButtonProps, L.Control.EasyButton> {
    createLeafletElement(props: ExistingFeaturesButtonProps): L.Control.EasyButton {
        return new L.Control.EasyButton({
            id: 'toggleShowExistingObjectsBtn',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'fas fa-database inactive',
                    title: 'Vis eksisterende vegobjekter i NVDB',
                    onClick: (btn: L.Control.EasyButton) => {
                        this.props.toggleShowExistingFeatures(this.getBoundingBox());
                        if(this.props.shouldEnable) {
                            btn.state('enable');
                        }
                    }
                },
                {
                    stateName: 'enable',
                    icon: 'fas fa-database active',
                    title: 'Bytt til vanlig modus',
                    onClick: (btn: L.Control.EasyButton) => {
                        this.props.toggleShowExistingFeatures(this.getBoundingBox());
                        btn.state('disabled');
                    }
                }
            ]
        });
    }

    getBoundingBox() {
        let bbox = this.props.leaflet.map.getBounds();

        return new BoundingBox(
            bbox.getNorthEast(),
            bbox.getSouthWest(),
            '4326');
    }
}

export default withLeaflet(ExistingFeaturesButton);
